import type { I } from '@/types/project';

export const proxyPrefixs: I.ProxyPrefix = {
  main: '/proxy-prefix-main',
  socket: '/proxy-prefix-socket',
  mqtt: '/proxy-prefix-mqtt',
  factoryPc: '/proxy-prefix-factory-pc',
};

export const apiHosts: I.ApiHosts = {
  // 项目主要使用域名：除以下特殊情况域名外都使用 main
  main: {
    // dev: proxyPrefixs.main,
    dev: 'https://eapi-pre.huolala.cn',
    stg: 'https://eapi-stg.huolala.cn',
    pre: 'https://eapi-pre.huolala.cn',
    prod: 'https://eapi.huolala.cn',
  },
  // websocket
  socket: {
    dev: proxyPrefixs.socket,
    stg: 'https://ewebappsocket-stg.huolala.cn',
    pre: 'https://ewebappsocket-pre.huolala.cn',
    prod: 'https://ewebappsocket.huolala.cn',
  },
  mqtt: {
    dev: proxyPrefixs.mqtt,
    stg: 'https://llrtc-center-stg.huolala.cn:1443/api',
    pre: 'https://llrtc-center-pre.huolala.cn:1443/api',
    prod: 'https://llrtc-center.huolala.cn/api',
  },
  factoryPc: {
    dev: 'https://factoring-pc-v-stg.huolala.cn',
    stg: 'https://factoring-pc-v-stg.huolala.cn',
    pre: 'https://factoring-pc-v-pre.huolala.cn',
    prod: 'https://factoring-pc-v.lalafin.net',
  },
  labao: {
    dev: 'https://labao-outward-v-stg.huolala.work',
    stg: 'https://labao-outward-v-stg.huolala.work',
    pre: 'https://labao-outward-v-pre.huolala.work',
    prod: 'https://ep.xiaoyuanins.com',
  },
  eappweb: {
    dev: 'https://eappweb-pre.huolala.cn',
    stg: 'https://eappweb-stg.huolala.cn',
    pre: 'https://eappweb-pre.huolala.cn',
    prod: 'https://eappweb.huolala.cn',
  },
  eapph5: {
    dev: 'https://eapph5-v-pre.huolala.cn',
    stg: 'https://eapph5-v-stg.huolala.cn',
    pre: 'https://eapph5-v-pre.huolala.cn',
    prod: 'https://eapph5-v.huolala.cn',
  },
  // 图片上传
  oimg: {
    dev: 'https://oimg-pre.huolala.cn',
    stg: 'https://oimg-stg.huolala.cn',
    pre: 'https://oimg-pre.huolala.cn',
    prod: 'https://oimg.huolala.cn',
  },
  accountAuthH5: {
    dev: 'https://account-auth-h5-v-pre.huolala.cn',
    stg: 'https://account-auth-h5-v-stg.huolala.cn',
    pre: 'https://account-auth-h5-v-pre.huolala.cn',
    prod: 'https://account-auth-h5-v.huolala.cn',
  },
};

const getVanSec = () => {
  const vanSec = (window?.document?.documentElement?.dataset?.vanSec ||
    'stable') as I.Sec;
  const secReplace = vanSec === 'stable' ? '' : `--${vanSec}`;
  return { vanSec, secReplace };
};
export const siteHosts: I.SiteHosts = {
  // 目前旧版 PC 开发环境有两个域名
  // dev: (isHome: boolean = true) =>  isHome ? 'http://localhost:8092/' : 'http://localhost:8202/',
  dev: (isHome: boolean = true) => {
    if (process.env.ONLY_MASTER === '1') {
      const env = process.env.ENV || 'stg';
      return `https://www-${env}.hllep.com/`;
    }
    return isHome ? 'http://localhost:8092/' : 'http://localhost:8202/';
  },
  stg: () => {
    const { vanSec, secReplace } = getVanSec();
    if (vanSec === 'stable') {
      return 'https://www-stg.hllep.com/';
    }
    return `https://e-pc${secReplace}-v-stg.huolala.cn/`;
  },
  pre: () => {
    const { vanSec, secReplace } = getVanSec();
    if (/^stable-[0-9]+$/.test(vanSec)) {
      return `https://e-pc${secReplace}-v-pre.huolala.cn/`;
    }
    return 'https://www-pre.hllep.com/';
  },
  prod: () => 'https://www.hllep.com/',
};

// 冷链pc多环境
export const cclPcHosts = {
  dev: () => {
    return 'http://localhost:8000'
  },
  stg: () => {
    const { vanSec, secReplace } = getVanSec();
    if (vanSec === 'stable') {
      return 'https://ccl-pc-v-stg.huolala.cn';
    }
    return `https://ccl-pc${secReplace}-v-stg.huolala.cn`;
  },
  pre: () => {
    const { vanSec, secReplace } = getVanSec();
    if (vanSec === 'stable') {
      return 'https://ccl-pc-v-pre.huolala.cn';
    }
    return `https://ccl-pc${secReplace}-v-pre.huolala.cn`;
  },
  prod: () => {
    return 'https://ccl-pc-v.huolala.cn'
  }
}
